import { IApplicationState } from 'shared/types/redux';

export const selectUtmTags = (state: IApplicationState) => state.landing.utmTags;
